import React, { useContext, useState } from "react";
import { Box } from "@mui/material";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import { AppContext } from "../AppContext";

const ImageWithPlaceholder = ({
    src,
    alt = "Image",
    style = {},
    placeholderIcon: PlaceholderIcon,
    placeholderIconSize = 40,
    placeholderIconColor = "#bbb",
    placeholderBackground = "#f5f5f5",
    placeholderBorder = "2px dashed #ddd",
    onError,
    onClick,
    ...props
}) => {
    const [imageError, setImageError] = useState(false);
    const { isRetailPos } = useContext(AppContext) || {};
    const DefaultPlaceholderIcon = isRetailPos ? CheckroomIcon : RestaurantIcon;
    const ResolvedPlaceholderIcon = PlaceholderIcon || DefaultPlaceholderIcon;

    const handleImageError = () => {
        setImageError(true);
        if (onError) {
            onError();
        }
    };

    const defaultImageStyle = {
        width: "100px",
        height: "100px",
        objectFit: "cover",
        borderRadius: "8px",
        ...style,
    };

    if (!src || imageError) {
        // Render placeholder when no image URL or image failed to load
        return (
            <Box
                sx={{
                    ...defaultImageStyle,
                    backgroundColor: placeholderBackground,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: placeholderBorder,
                    cursor: onClick ? "pointer" : "default",
                }}
                onClick={onClick}
                {...props}
            >
                <ResolvedPlaceholderIcon
                    sx={{
                        fontSize: placeholderIconSize,
                        color: placeholderIconColor,
                    }}
                />
            </Box>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            style={{
                ...defaultImageStyle,
                cursor: onClick ? "pointer" : "default",
            }}
            onError={handleImageError}
            onClick={onClick}
            {...props}
        />
    );
};

export default ImageWithPlaceholder; 